import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { WebPlayer } from '@studio/types';

export const root = {};

export const id = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webplayer/library/@id`,
    request: {} as WebPlayer.Post.WebPlayer,
    params: {} as { id: string },
    method: HTTP_METHODS.POST,
  },
};
